import DepositIcon from './deposit.png';
import TradeIcon from './trade.png';
import SubmitIcon from './submit.png';

export default {
  DepositIcon,
  TradeIcon,
  SubmitIcon,
};
